/* eslint-disable no-nested-ternary */
import React, { useState, useContext } from 'react';
import { isEmpty, kebabCase } from 'lodash';
import { getTranslationByKey } from '../../helpers/translation-helper';
import { DWTCContext } from '../../utils/context';
import {
  FaqsDesktopWrapper,
  FaqsContainer,
  FaqsCardsWrapper,
  FaqsCards,
  FaqsCard,
  FaqsTitle,
  FaqsQuestionAnswerWrapper,
  FaqsQuestionAnswer,
  FaqsQuestion,
  FaqsAnswer,
} from '../styles/Faqs.styled';
import Sprites from '../Sprites';

export default function FaqsDesktop({ data, dir }) {
  const [activeCategories, setActiveCategories] = useState({});
  const [isAnyCardActive, setIsAnyCardActive] = useState(false);

  const handleFaqsCardClick = (rowIndex, category) => {
    setActiveCategories((prevActiveCategories) => {
      const updatedCategories = { ...prevActiveCategories };
      Object.keys(updatedCategories).forEach((rowIndexStr) => {
        const index = parseInt(rowIndexStr, 10);
        if (index !== rowIndex) {
          updatedCategories[index] = null;
        }
      });
      updatedCategories[rowIndex] = updatedCategories[rowIndex] === category ? null : category;
      const anyCardActive = Object.values(updatedCategories).some((value) => !!value);
      setIsAnyCardActive(anyCardActive);

      return updatedCategories;
    });
  };

  const uniqueCategories = Array.from(new Set(data.questions.map((item) => item.content.category)));

  const createCardRows = () => {
    const rows = [];
    const cardsPerRow = 5;
    for (let i = 0; i < uniqueCategories.length; i += cardsPerRow) {
      const row = uniqueCategories.slice(i, i + cardsPerRow);
      if (!isEmpty(row)) {
        rows.push(row);
      }
    }
    return rows;
  };

  const { translations } = useContext(DWTCContext);

  const categorySubtitles = {};
  data.questions.forEach((item) => {
    if (!categorySubtitles[item.content.category]) {
      categorySubtitles[item.content.category] = item.content.subtitle;
    }
  });

  return (
    <FaqsDesktopWrapper>
      <FaqsContainer>
        {createCardRows().map((row, rowIndex) => (
          <FaqsCardsWrapper key={rowIndex}>
            <FaqsCards>
              {isEmpty(row) ||
                row.map(
                  (category, colIndex) =>
                    !isEmpty(category) && (
                      <FaqsCard
                        key={colIndex}
                        onClick={() => handleFaqsCardClick(rowIndex, category)}
                        className={`${isAnyCardActive ? 'card-opacity' : ''} ${
                          activeCategories[rowIndex] === category
                            ? 'active-card smoothed'
                            : activeCategories[rowIndex]
                            ? 'card-opacity'
                            : 'smoothed'
                        }`}
                      >
                        <Sprites name={kebabCase(category)} />
                        <FaqsTitle
                          dir={dir}
                          className={`${
                            activeCategories[rowIndex] === category ? 'active-title' : ''
                          }`}
                        >
                          {getTranslationByKey(translations, category)}
                        </FaqsTitle>
                        {/* {isEmpty(categorySubtitles) || (
                          <FaqsDescription
                            dir={dir}
                            className={`${
                              activeCategories[rowIndex] === category ? 'active-description' : ''
                            }`}
                          >
                            {categorySubtitles[category]}
                          </FaqsDescription>
                        )} */}
                      </FaqsCard>
                    ),
                )}
            </FaqsCards>
            {activeCategories[rowIndex] && (
              <FaqsQuestionAnswerWrapper className="smoothed" dir={dir}>
                <button type='button'
                onClick={() => handleFaqsCardClick(activeCategories[rowIndex])}
                ><Sprites name='close-rounded'/></button>
                {data.questions
                  .filter((item) => item.content.category === activeCategories[rowIndex])
                  .map((item, index) => (
                    <FaqsQuestionAnswer key={index}>
                      <FaqsQuestion dir={dir}>
                        {index + 1}. {item.content.question}
                      </FaqsQuestion>
                      <FaqsAnswer dangerouslySetInnerHTML={{ __html: item.content.answer }} />
                    </FaqsQuestionAnswer>
                  ))}
              </FaqsQuestionAnswerWrapper>
            )}
          </FaqsCardsWrapper>
        ))}
      </FaqsContainer>
    </FaqsDesktopWrapper>
  );
}
